import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PlanModalContextType {
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

const PlanModalContext = createContext<PlanModalContextType | undefined>(undefined);

export function PlanModalProvider({ children }: { children: ReactNode }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <PlanModalContext.Provider value={{ isModalOpen, openModal, closeModal }}>
      {children}
    </PlanModalContext.Provider>
  );
}

export function usePlanModal() {
  const context = useContext(PlanModalContext);
  if (context === undefined) {
    throw new Error('usePlanModal must be used within a PlanModalProvider');
  }
  return context;
}
